import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Form, Input, Select, Checkbox, TreeSelect, AutoComplete } from 'antd';
const FormItem = Form.Item;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const TreeNode = TreeSelect.TreeNode;

import * as settingActions from '../../actions/setting_action';
import Utils from '../../script/utils.js';

class UserFormModal extends Component {
  state={
    userFormSubmitLoading: false
  }

  submitUserForm = () => {
    let { userManageModalType } = this.props;
    // console.log(this.props);
    this.userForm.smformRef.current.validateFields().then((values) => {
      console.log(values);
      if (values) {
        // console.log(this.props);
        var roleName = '';
        var roleNameArr = this.userForm.smformRef.current.getFieldValue('Roles');
        for (var i = 0; i < roleNameArr.length; i++) {
          if (roleName == '') {
            roleName = roleNameArr[i];
          }
          else {
            roleName += ','+roleNameArr[i];
          }
        }
        var params = {
          LoginId: this.userForm.smformRef.current.getFieldValue('LoginID'),
          OranizationName: this.userForm.smformRef.current.getFieldValue('GroupName'),
          RoleName: roleName,
          UserName: this.userForm.smformRef.current.getFieldValue('DisplayName'),
          Email: this.userForm.smformRef.current.getFieldValue('Email'),
        };
        if(userManageModalType == 'edit_user'){
          params.Operate = 'edit';
          params.partyId = this.props.selectedUser ? this.props.selectedUser.RecId : '';
        }else{
          params.Operate = 'add';
          params.PassWd = this.userForm.smformRef.current.getFieldValue('password');
        }
        // 新架构（doc/03）：角色与运维团队统一为 SecurityGroup（groupIds 逗号分隔）
        // 角色勾选值 + 运维团队合并去重后提交
        var groupIdArr = [];
        (roleNameArr || []).forEach(r => { if (groupIdArr.indexOf(r) == -1) groupIdArr.push(r); });
        var _team = this.userForm.smformRef.current.getFieldValue('GroupName');
        if (_team && groupIdArr.indexOf(_team) == -1) groupIdArr.push(_team);
        params.groupIds = groupIdArr.join(',');
        if (this.userForm.smformRef.current.getFieldValue('Cellphone')) {
          params.Cellphone = this.userForm.smformRef.current.getFieldValue('Cellphone');
        }
        if (this.userForm.smformRef.current.getFieldValue('Area')) {
          // var area = '';
          // var areaArr = this.userForm.smformRef.current.getFieldValue('Area');
          // for (var i = 0; i < areaArr.length; i++) {
          //   if (area == '') {
          //     area = areaArr[i];
          //   }
          //   else {
          //     area += ','+areaArr[i];
          //   }
          // }
          params.Area = this.userForm.smformRef.current.getFieldValue('Area');
        }
        if (this.userForm.smformRef.current.getFieldValue('UnitName')) {
          params.Company = this.userForm.smformRef.current.getFieldValue('UnitName');
        }
        if (this.userForm.smformRef.current.getFieldValue('Department')) {
          params.Department = this.userForm.smformRef.current.getFieldValue('Department');
        }
        if (this.userForm.smformRef.current.getFieldValue('Office')) {
          params.Office = this.userForm.smformRef.current.getFieldValue('Office');
        }
        if (this.userForm.smformRef.current.getFieldValue('Supervisor')) {
          params.Supervisor = this.userForm.smformRef.current.getFieldValue('Supervisor');
        }
        if (this.userForm.smformRef.current.getFieldValue('Status')) {
          params.Status = this.userForm.smformRef.current.getFieldValue('Status');
        }
        this.setState({ userFormSubmitLoading: true });
        this.props.settingActions.operateUser(params, (res)=>{
          if (params.Operate == 'add') {
            if (res == 'success') {
              Utils.showMessageDialog("提示", "添加成功。");
            }
            else {
              Utils.showMessageDialog("提示", res=='error' ? "添加失败。" : res);
            }
          }
          this.setState({ userFormSubmitLoading: false });
          if (this.props.personalInfo) {
            this.props.setState({
              personalInfoModalShow: false
            });
          } else {
            this.props.setState({
              userManageModalType: '',
              userManageModalShow: false
            });
          }
          this.props.getUserList && this.props.getUserList();
        }, this.props.personalInfo);
      }
    });
    // console.log(this.props);
  }

  render() {
    return (
      <div>
        <WrappedUserForm {...this.props} wrappedComponentRef={inst => this.userForm = inst}/>
        <div className="ant-modal-footer" style={{margin: '24px -24px -24px'}}>
          {this.props.selectedUser && this.props.selectedUser.LoginID == 'admin' || (this.props.personalInfo && !Utils.hasPermission('personal', 'edit')) ? null : <Button key="submit" type="primary" onClick={this.submitUserForm} loading={this.state.userFormSubmitLoading}>保存</Button>}
          <Button key="back" onClick={this.props.closeModal}>取消</Button>
        </div>
      </div>
    );
  }
}

class UserForm extends Component {
  constructor(props) {
		super(props);
		this.state = {
		};
    this.smformRef=React.createRef()
    let { wrappedComponentRef } = props;
		if (typeof wrappedComponentRef=== 'function') {
			wrappedComponentRef(this); // 在这里把this暴露给`parentComponent`
		}
	}
  // state={
  // }

  componentDidMount(){
    let { selectedUser } = this.props;
    if (selectedUser.GroupName) {
      this.props.settingActions.getOrganizationRoleData(selectedUser.GroupName);
    }
    else {
      this.props.settingActions.setOrganizationRoleData([]);
    }

    if (selectedUser.Department) {
      this.props.settingActions.getDepartmentJobData(selectedUser.Department);
    }
    else {
      this.props.settingActions.setDepartmentJobData([]);
    }
  }

  validatePassword = (rule, value, callback) => {
    if (value.length < 6 || value.length > 18) {
      callback('密码长度应为6-18');
    } else {
      callback();
    }
  }

  comparePassword = (rule, value, callback) => {
    const form = this.smformRef.current;
    if (value && value !== form.getFieldValue('password')) {
      callback('密码不一致');
    } else {
      callback();
    }
  }

  validateEmail = (rule, value, callback) => {
    // const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    const reg = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
    if (!reg.test(value)) {
      callback('邮箱格式不正确');
    } else {
      callback();
    }
  }

  handleChangeSelect = (key, value) => {
    if (key == 'GroupName') {
      this.smformRef.current.setFieldsValue({Roles: []});
      this.props.settingActions.getOrganizationRoleData(value);
    }
    else if (key == 'Department') {
      this.smformRef.current.setFieldsValue({Office: ''});
      this.props.settingActions.getDepartmentJobData(value);
    }
  }

  render() {
    //表单方法
    // let { getFieldDecorator } = this.smformRef.current;
    let { userManageModalType, selectedUser, userList, organizationData, organizationRoleData, areaData, unitData, departmentData, departmentJobData, personalInfo } = this.props;
    selectedUser = selectedUser || {};

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
    return (
      <Form className="basicCustomForm userForm" ref={this.smformRef}>
        <FormItem label="用户名" {...formItemLayout} name={'LoginID'} initialValue={ selectedUser.LoginID || ''} rules={ [{ required: true, message: '用户名不能为空' }]}>
        <Input disabled={userManageModalType=='edit_user' ? true : false} />
        </FormItem>
        { personalInfo ? null : <FormItem label="密码" {...formItemLayout} name={'password'} initialValue={ userManageModalType=='edit_user' ? '******' : ''}
        rules={[
          { required: true, message: '密码不能为空' },
          { validator: this.validatePassword }
        ]}
        >
          <Input type="password" placeholder="长度为6-18任意组合的密码" disabled={userManageModalType=='edit_user' ? true : false} />
        </FormItem> }
        { personalInfo ? null : <FormItem label="确认密码" {...formItemLayout} name={'passwordConfirm'} initialValue={ userManageModalType=='edit_user' ? '******' : ''}
        rules={[
          { required: true, message: '确认密码不能为空' },
          { validator: this.comparePassword }
        ]}
        >
         <Input type="password" disabled={userManageModalType=='edit_user' ? true : false} />
        </FormItem> }
        <FormItem label="运维团队" {...formItemLayout} name={'GroupName'} initialValue={selectedUser.GroupName || ''} rules={[{ required: true, message: '请选择运维团队' }]}>
        <Select onChange={this.handleChangeSelect.bind(this, 'GroupName')} disabled={personalInfo ? true : false}>
              {organizationData.map(organization => <Option key={organization.RecId} value={organization.o_name}>{organization.o_name}</Option>)}
            </Select>
        </FormItem>
        <FormItem label="角色" {...formItemLayout} name={'Roles'} initialValue={ selectedUser.Roles || []} rules={ [{ type: 'array', required: true, message: '请选择角色' }]}>
        <CheckboxGroup className="roleCbGroup" disabled={personalInfo ? true : false}>
              {organizationRoleData.map(organizationRole => <Checkbox key={organizationRole.Role} value={organizationRole.Role}><span title={organizationRole.RoleDescription}>{organizationRole.Role}</span></Checkbox>)}
            </CheckboxGroup>
        </FormItem>
        <FormItem label="姓名" {...formItemLayout} name={'DisplayName'} initialValue={ selectedUser.DisplayName || ''} rules={[{ required: true, message: '姓名不能为空' }]}>
        <Input placeholder="请输入您的名字" />
        </FormItem>
        <FormItem label="邮箱" {...formItemLayout} name={'Email'} initialValue={selectedUser.Email || ''} rules={[
              { required: true, message: '邮箱不能为空' },
              { validator: this.validateEmail }
            ]}>
         <Input />
        </FormItem>
        <FormItem label="电话" {...formItemLayout} name={'Cellphone'} initialValue={selectedUser.Cellphone || ''}>
        <Input />
        </FormItem>
        <FormItem label="区域" {...formItemLayout} name={'Area'} initialValue={selectedUser.Area ? selectedUser.Area.split(',') || [] : []}>
        <TreeSelect
              dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
              treeData={areaData}
              allowClear
              multiple
              treeDefaultExpandAll
            />
        </FormItem>
        <FormItem label="单位" {...formItemLayout} name={'UnitName'} initialValue={selectedUser.UnitName || ''}>
        <Select
              showSearch
              optionFilterProp="children"
              onChange={this.handleChangeSelect.bind(this, 'UnitName')}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {unitData.map(unit => <Option key={unit.RecId} value={unit.Name}>{unit.Name}</Option>)}
            </Select>
        </FormItem>
        <FormItem label="部门" {...formItemLayout} name={'Department'}  initialValue={selectedUser.Department || ''} >
        <Select onChange={this.handleChangeSelect.bind(this, 'Department')}>
              {departmentData.map(department => <Option key={department.RecId} value={department.DepartmentName}>{department.DepartmentName}</Option>)}
            </Select>
        </FormItem>
        <FormItem label="职位" {...formItemLayout} name={'Office'} initialValue={selectedUser.Office || ''}>
        <AutoComplete
              filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            >
              {departmentJobData.map(departmentJob => <Option key={departmentJob.RecId} value={departmentJob.JobTitle}>{departmentJob.JobTitle}</Option>)}
            </AutoComplete>
        </FormItem>
        <FormItem label="主管人" {...formItemLayout} name={'Supervisor'} initialValue={selectedUser.Supervisor || ''}>
        <Select onChange={this.handleChangeSelect.bind(this, 'Supervisor')}>
              <Option key="" value=""><div style={{height: 22}} /></Option>
              {userList.map(user => <Option key={user.LoginID} value={user.DisplayName}>{user.DisplayName}</Option>)}
            </Select>
        </FormItem>
        <FormItem label="状态" {...formItemLayout} name={'Status'} initialValue={selectedUser.Status || '活动'}>
        <Select onChange={this.handleChangeSelect.bind(this, 'Status')}>
              <Option value="活动">活动</Option>
              <Option value="休假">休假</Option>
              <Option value="已终止">已终止</Option>
            </Select>
        </FormItem>
      </Form>
    );
  }
}

const WrappedUserForm = (UserForm);
const mapStateToProps = (state) => {
  const { userList, organizationData, organizationRoleData, areaData, unitData, departmentData, departmentJobData } = state.settingReducer;
  return {
    userList,
    organizationData,
    organizationRoleData,
    areaData,
    unitData,
    departmentData,
    departmentJobData
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    settingActions: bindActionCreators(settingActions, dispatch)
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserFormModal)
